<template>
  <div class="list posRe">
    <template v-if="lists&&lists.length">
      <div class="swiper-container container-list" :class="['container'+className]">
        <div class="swiper-wrapper">
          <template  v-for="(item,index) in lists">
            <div class="swiper-slide" :data-i="index" :key="'lists'+index">
              <template v-if="item&&item.length">
                <div class="clearFloat">
                  <template v-for="(only,i) in item">
                    <only-list :class-name="className+index+'-'+i" :item="only" :lazy="lazy" :key="'only-item'+index+i"></only-list>
                  </template>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
    <div class="top-right" v-if="total>4">
      <div class="next-list next-list-change" @click="changeData" :class="['next-list-'+className]">
        <span class="icon-img icon-change"></span>
        换一换
      </div>
    </div>
  </div>
</template>

<script>
import onlyList from '@/components/onlyList'
export default {
  props: ['listUrl', 'className'],
  name: 'list',
  data () {
    return {
      listsAll: [],
      lists: [],
      lazy: {
        bool: true,
        elementClass: 'list-img'
      },
      total: 0,
      params: {
        page: 1,
        cityId: 0,
        limit: 4
      },
      page: 1,
      containerSwiper1: ''
    }
  },
  components: {
    onlyList: onlyList
  },
  created () {
    let that = this
    let currentParams = JSON.parse(this.publicJs.decode(that.$route.query))
    that.params.cityId = currentParams.cityId || 0
    that.httpData()
  },
  mounted () {
  },
  methods: {
    httpData: function () { // 获取对应的数据
      let _that = this
      _that.httpAjax.getAjax(_that.listUrl, _that.params).then(function (data) {
        if (data.code === 1) {
          if (_that.params.page === 1 && (!data.data || data.data.length <= 0)) {
            _that.$emit('empty', false)
          } else {
            _that.$emit('empty', true)
          }
          let newData = JSON.parse(JSON.stringify(data.data))
          _that.total = data.total
          while (_that.lists.length < Math.ceil(data.total / _that.params.limit)) {
            _that.lists.splice(0, 0, [])
          }
          _that.$set(_that.lists, _that.params.page - 1, newData)
          if (_that.params.page === 1) {
            _that.$nextTick(function () {
              setTimeout(function () {
                _that.swiperFun()
              }, 50)
            })
          }
        }
      }, function (err) {
        console.log(err)
      })
    },
    swiperFun: function () {
      let that = this
      that.containerSwiper1 = new Swiper('.container' + that.className, {
        slidesPerView: 1,
        spaceBetween: 0,
        lazy: {
          // loadPrevNext: true,
          elementClass: that.lazy.elementClass
        },
        observer: true,
        observeSlideChildren: true,
        observeParents: true,
        watchOverflow: true,
        on: {
          slideChangeTransitionStart: function () {
            let i = this.activeIndex
            if (!that.lists[i].length) {
              that.params.page = (i + 1)
              that.page = (i + 1)
            }
          }
        }
      })
    },
    changeData: function () {
      let that = this
      let n = that.containerSwiper1.realIndex
      if ((that.lists.length - 1) === n) {
        that.containerSwiper1.slideTo(0)
      } else {
        that.containerSwiper1.slideTo(n + 1)
      }
    }
  },
  computed: {},
  watch: {
    page: {
      handler: function (a, b) {
        if (a !== b) {
          this.httpData()
        }
      },
      deep: true
    },
    listUrl: {
      handler: function (a, b) {
        if (this.page === 1) {
          this.httpData()
        }
        if (a !== b) {
          this.page = 1
          this.params.page = 1
          this.lists = []
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .list{
    padding-bottom: 20px;
    margin: 0 -6px;
  }
  .clearFloat{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .clearFloat>div{
    width: 50%;
  }
  .container-city-recommend .clearFloat>div,
  .container-city-new .clearFloat>div{
    width: 100%;
  }
  .top-right{
    position: absolute;
    right: 6px;
    top:-28px;
    padding-left: 20px;
  }
  .next-list-change{
    font-size: 12px;
  }
  .icon-change{
    width: 16px;
    height: 16px;
    background-position: -109px -209px;
    top:50%;
    left: 0;
    margin-top: -8px;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/Phone/list.vue